// extracted by mini-css-extract-plugin
module.exports = {"link":"_5b10bb2305--link--R41Y7"};